module.exports = __webpack_public_path__ + "img/qm6.2c7a26f4.jpg";